import { render, staticRenderFns } from "./CheckinReviewPage.vue?vue&type=template&id=52e270ae&"
import script from "./CheckinReviewPage.vue?vue&type=script&lang=js&"
export * from "./CheckinReviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports